import React from 'react';
//eslint-disable-next-line
import styles from "./styles.scss";

const DotSeparator = () => {
  return <div className={'separator'} />;
};
export default DotSeparator;
